/**
 *
 * Une fonction de base pour faire un Show / Hide sur un élémént.
 * Exemple : Toggle display:none au clic pour le dropdown du form.
 *
 * @param {DOMElement} element
 * @param {string} attribut
 * @param {string} value
 */
export function toggle_attr (element, attribut, value) {

    if (element.hasAttribute(attribut)) {
        element.removeAttribute(attribut);
    } else {
        element.style.display = value;
    }
}

/**
 * Serialize all form data into a JSON string
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {HTMLFormElement} form The form to serialize
 * @returns {String} The serialized form data
 */
export function serializeJSON (form) {
    var obj = {};
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
      if (field.type === 'select-multiple') {
        var options = [];
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          options.push(option.value);
        });
        if (options.length) {
          obj[field.name] = options;
        }
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
      if(field.name.includes("[]")) {
        let name = field.name.replace('[]','');

        if (!(name in obj)) {
            obj[name] = [];
        }

        obj[name].push(field.value);
        return;
      }
      obj[field.name] = field.value;
    });
    return obj;
  }
